import { render, staticRenderFns } from "./TabelasEValores.vue?vue&type=template&id=590b6b74&"
import script from "./TabelasEValores.vue?vue&type=script&lang=js&"
export * from "./TabelasEValores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports